// extracted by mini-css-extract-plugin
export var repository__description = "index-module--repository__description--19a70";
export var repository__link = "index-module--repository__link--824f1";
export var repository__name = "index-module--repository__name--d1764";
export var repository__tag = "index-module--repository__tag--39c99";